import type { MapInteractionEventData } from '../trackMapInteraction';

import { trackMapInteraction } from '../trackMapInteraction';

export const trackFullscreenToggleOnce = (
  map: google.maps.Map,
  toggleFullscreen: MapInteractionEventData,
): void => {
  let clearFullscreenListener: undefined | (() => void);

  const trackToggleFullscreen: EventListener = ({ target }) => {
    const isFullscreen = document.fullscreenElement !== null;
    if (!target || !isFullscreen) return;
    const isFullscreenMap = map.getDiv().contains(target as Node);
    if (isFullscreenMap) {
      trackMapInteraction(toggleFullscreen);
      clearFullscreenListener?.();
    }
  };

  [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'msfullscreenchange',
  ].forEach((eventType) => {
    document.addEventListener(eventType, trackToggleFullscreen);
    clearFullscreenListener = () => {
      [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'msfullscreenchange',
      ].forEach((type) => {
        document.removeEventListener(type, trackToggleFullscreen);
      });
    };
  });
};
